import React, { useEffect } from 'react';
import { InformationList } from '@/components/organisms';
import useAppToast from '@/hooks/useAppToast';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Tenant Dashboard Component
 *
 * Legacy parity: RA2 /home
 */
export const TenantDashboard: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const toast = useAppToast();
  const flashMessage = (location.state as { flashMessage?: string } | null)?.flashMessage;

  useEffect(() => {
    if (!flashMessage) return;
    toast.success(flashMessage, { key: 'flash-password-reset' });
    navigate(location.pathname, { replace: true, state: null });
  }, [flashMessage, location.pathname, navigate, toast]);

  return (
    <div className="container mx-auto">
      <div className="flex justify-center">
        <div className="w-full max-w-3xl">
          <InformationList />
        </div>
      </div>
    </div>
  );
};
